import axios from 'axios';

import { parseProductNameFromURLQuery } from '../utils/branding';
import { toProperCase } from '../utils/string';

const idmApi = axios.create({
  baseURL: process.env.REACT_APP_IDM_API_URL,
});

export async function getBrandingForProduct() {
  try {
    const product = parseProductNameFromURLQuery(window.location.search);
    const isIDM = product === 'idm';

    if (!product || isIDM) {
      return Promise.resolve('catapult');
    }

    const response = await idmApi.get(`/products/${toProperCase(product)}/branding`);
    return Promise.resolve(response.data.message);
  } catch (error) {
    return Promise.reject(error);
  }
}
